import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getRoles = ({
  churchId,
  isDenomination = false,
  denominationId
}) => {
  return axios.get(
    `/${isDenomination ? "denominations" : "churches"}/${
      isDenomination ? denominationId : churchId
    }/roles`
  );
};

export const useRoles = ({
  churchId,
  isDenomination = false,
  denominationId,
  config
} = {}) => {
  return useQuery({
    ...config,
    queryKey: ["roles", isDenomination ? denominationId : churchId],
    queryFn: () => getRoles({ churchId, isDenomination, denominationId })
  });
};
